import { PublicationType } from '../../constants';
import { PAGE_TEXT } from '../../../../lang';
import type { SelectOption } from '../../../../../../components';

const PUBLICATION_TYPE =
  PAGE_TEXT.DRC_ASSESSMENT_DETAILS.ASSESSMENT.STEP_B.PUBLICATION_TYPE;
export const publicationTypeOptions: SelectOption[] = [
  {
    label: PUBLICATION_TYPE.JCR_Q1,
    value: PublicationType.JCR_Q1,
  },
  {
    label: PUBLICATION_TYPE.JCR_Q2,
    value: PublicationType.JCR_Q2,
  },
  {
    label: PUBLICATION_TYPE.JCR_Q1_EQUIVALENT,
    value: PublicationType.JCR_Q1_EQUIVALENT,
  },
  {
    label: PUBLICATION_TYPE.JCR_Q2_EQUIVALENT,
    value: PublicationType.JCR_Q2_EQUIVALENT,
  },
  {
    label: PUBLICATION_TYPE.NA,
    value: PublicationType.NA,
  },
];
